module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_7-min.6d4ccc03.jpg";